import { Helmet } from 'react-helmet-async';
const PageTitle = ({ title }) => {
    return (
        <Helmet>
            <title>Toursxplorer | {title}</title>
        </Helmet>
    )
}
export default PageTitle;